import { render } from "./EquipmentcategoriesDataTable.vue?vue&type=template&id=513ede07"
import script from "./EquipmentcategoriesDataTable.vue?vue&type=script&lang=js"
export * from "./EquipmentcategoriesDataTable.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__